import Immutable from 'immutable';
import {createStore, applyMiddleware} from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension/logOnlyInProduction';
import thunk from 'redux-thunk';
import {routerMiddleware} from 'connected-react-router/immutable';

import createRootReducer from './reducers';
import history from './services/history';
import navigationFluxesMiddleware from './services/navigationFluxesMiddleware';

const composeEnhancers = composeWithDevTools({
  name: 'Skillup',
  serialize: {
    immutable: Immutable,
  },
});

export default function store(initialState) {
  const middlewares = [thunk, routerMiddleware(history), navigationFluxesMiddleware(history)];

  const store = createStore(
    createRootReducer(history),
    initialState,
    composeEnhancers(applyMiddleware(...middlewares))
  );

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      store.replaceReducer(createRootReducer(history));
    });
  }

  return store;
}
